import styled from 'styled-components';

export const UsersCount = styled.span`
  cursor: pointer;
  font-weight: bold;
  color: ${(props) => props.theme.config.colors.secondary};
`;
